export { default } from './PublicationList';

require('./PublicationList.scss');